"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleIcon = void 0;
var answers_ui_libby_1 = require("@wix/answers-ui-libby");
var React = require("react");
// tslint:disable:max-line-length
var svgData = "\n\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"31\" viewBox=\"0 0 24 31\">\n\t\t<path d=\"M1 2v27c0 .55.45 1 1 1h20c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1H2c-.55 0-1 .45-1 1zM0 2C0 .9.9 0 2 0h20c1.1 0 2 .9 2 2v27c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2zm5 9h8v-1H5v1zm0 2v1h13v-1H5zm0 3v1h13v-1H5zm0 3v1h13v-1H5z\"/>\n\t</svg>\n";
exports.ArticleIcon = function () { return React.createElement(answers_ui_libby_1.Icon, { icon: svgData }); };
//# sourceMappingURL=article-icon.js.map